import React, { createContext, useContext } from 'react';

// Theme Context
export const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

// Authentication Context
export const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

// Toast Notification Context
export const ToastContext = createContext();

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};

// Agency Context for Super Admin to switch between agencies
export const AgencyContext = createContext();

export const useAgencyContext = () => {
  const context = useContext(AgencyContext);
  if (!context) {
    throw new Error('useAgencyContext must be used within AgencyContextProvider');
  }
  return context;
};

// Mobile Navigation Context — controls the mobile slide-in drawer
// used by both the main app Sidebar and the ICS Sidebar.
export const MobileNavContext = createContext({
  mainDrawerOpen: false,
  setMainDrawerOpen: () => {},
  icsDrawerOpen: false,
  setIcsDrawerOpen: () => {},
});

export const useMobileNav = () => useContext(MobileNavContext);
